import slice from './bootstrapSlice';

export * from './types';

export const {
  loadBootstrap,
  updateSchemaConfig,
  setFormatSetting,
  setGeoMapData,
  clearBootstrap,
  updateReportSetting,
  updateLlmApiEnabled,
  updateCustomerPlan,
} = slice.actions;
export default slice.reducer;
